var _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJobSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "job-search",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1344",
    "data-name": "Group 1344",
    transform: "translate(3.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1343",
    "data-name": "Group 1343",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_924",
    "data-name": "Path 924",
    d: "M128.25,8a.993.993,0,0,0-.75.346.987.987,0,0,0-1.5,0,.98.98,0,0,0-1.25-.207V7.362l.1-.027.073-.024c.075-.025.15-.051.223-.081L125.2,7.2q.127-.053.249-.115l.013-.007a3.744,3.744,0,0,0,.946-.69.26.26,0,0,0,.018-.028,3.748,3.748,0,1,0-5.35.011c0,.005.006.012.011.017s.036.033.053.049l.038.036q.094.089.195.171l.06.049q.1.079.206.15l.052.036c.087.057.175.11.266.16l.064.032c.071.037.142.071.215.1l.1.042c.066.027.134.052.2.075l.1.033.109.032v3.785l-.814-.815a1.134,1.134,0,1,0-1.6,1.6l2.418,2.418v.4A.25.25,0,0,0,123,15h5.75a.25.25,0,0,0,.25-.25V13.81l.224-.447a.25.25,0,0,0,.026-.112V9A1,1,0,0,0,128.25,8Zm-7.118-2.332A3.243,3.243,0,0,1,123.589.5a3.243,3.243,0,0,1,2.778,5.163,2.769,2.769,0,0,0-1.5-1.674,1.5,1.5,0,1,0-2.243,0A2.767,2.767,0,0,0,121.133,5.669ZM124.75,3a1,1,0,0,1-.5.862l0,0a1.034,1.034,0,0,1-.214.092l-.04.012c-.027.007-.054.012-.081.017a1,1,0,0,1-.138.014h-.044a.966.966,0,0,1-.138-.014c-.027,0-.055-.01-.081-.017l-.04-.012a1.048,1.048,0,0,1-.214-.092l0,0A1,1,0,1,1,124.75,3Zm-2,3v.841a3.261,3.261,0,0,1-.306-.117l-.083-.04q-.106-.05-.207-.107l-.1-.055c-.065-.04-.128-.082-.19-.126-.027-.019-.056-.038-.082-.058q-.121-.092-.233-.195l-.021-.021A2.26,2.26,0,0,1,123.1,4.35a1.48,1.48,0,0,0,1.3,0,2.259,2.259,0,0,1,1.564,1.769c-.034.032-.067.064-.1.095l-.022.018a3.324,3.324,0,0,1-.378.277l-.017.012c-.048.03-.1.056-.148.083s-.094.05-.141.073-.082.039-.124.057c-.087.037-.176.073-.267.1l-.017.006V6a1,1,0,0,0-2,0Zm6,7.191-.224.447a.25.25,0,0,0-.026.112v.75h-5.25v-.25a.249.249,0,0,0-.073-.177l-2.491-2.491a.634.634,0,0,1,.9-.9l1.241,1.241a.25.25,0,0,0,.427-.177V6a.5.5,0,1,1,1,0v4.5h.5V9a.5.5,0,1,1,1,0v1.5h.5V9a.5.5,0,1,1,1,0v1.5h.5V9a.5.5,0,0,1,1,0Z",
    transform: "translate(-120 -0.001)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1346",
    "data-name": "Group 1346",
    transform: "translate(0 2.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1345",
    "data-name": "Group 1345"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_925",
    "data-name": "Path 925",
    d: "M2.555,82.2a1.25,1.25,0,1,0-1.611,0A1.751,1.751,0,0,0,0,83.749v.75a.25.25,0,0,0,.25.25h3a.25.25,0,0,0,.25-.25v-.75A1.751,1.751,0,0,0,2.555,82.2ZM1.75,80.5a.75.75,0,1,1-.75.75A.751.751,0,0,1,1.75,80.5ZM3,84.249H.5v-.5a1.25,1.25,0,1,1,2.5,0Z",
    transform: "translate(0 -79.999)"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1348",
    "data-name": "Group 1348",
    transform: "translate(11.5 2.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1347",
    "data-name": "Group 1347"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_926",
    "data-name": "Path 926",
    d: "M370.555,74.2a1.25,1.25,0,1,0-1.61,0A1.751,1.751,0,0,0,368,75.749v.75a.25.25,0,0,0,.25.25h3a.25.25,0,0,0,.25-.25v-.75A1.751,1.751,0,0,0,370.555,74.2Zm-.805-1.7a.75.75,0,1,1-.75.75A.751.751,0,0,1,369.75,72.5Zm1.25,3.75h-2.5v-.5a1.25,1.25,0,1,1,2.5,0Z",
    transform: "translate(-368 -71.999)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobSearch);
export default __webpack_public_path__ + "static/media/job-search.3f7b8e43.svg";
export { ForwardRef as ReactComponent };